import type { ProjectRevenueState } from '@inou/shared';

import { TdNum } from '@/components/ui/table';
import { hours, yenExact } from '@/lib/format';

/**
 * 想定売上・粗利のセル。
 *
 * 数字を出すのは「請求可能な工数があり、その全部に売上単価が解決できている」
 * ときだけ。それ以外は計算した数字ではなく理由を出す。売上単価が未設定のとき
 * 0 円/時で計算すると 粗利 = -原価 になり、嘘の赤字を意思決定に使わせてしまう。
 *
 *   対象外     : 請求可能な工数が無い (自社プロダクト等)。売上 0 は正しく、
 *                粗利という指標がこの行に存在しないだけなので中立色。
 *   単価未設定 : 入力の穴。直せば数字が出るので「要確認」= alert。
 *   一部未設定 : 同上。計算すると必ず過小になるうえ、もっともらしい数字で
 *                出るぶん全員未設定より気づかれにくいので、こちらも出さない。
 */
const LABEL: Record<Exclude<ProjectRevenueState, 'ok'>, string> = {
  not_billable: '対象外',
  missing_rate: '単価未設定',
  partial_rate: '一部未設定',
};

export function RevenueCell({
  amount,
  state,
  unratedHours,
}: {
  amount: number | null;
  state: ProjectRevenueState;
  /** 単価が引けない請求可能工数。穴の大きさが分かると、直すか放置するかを選べる。 */
  unratedHours: number;
}) {
  if (state === 'ok' && amount !== null) {
    return <TdNum className={amount < 0 ? 'text-alert' : undefined}>{yenExact(amount)}</TdNum>;
  }

  return (
    <TdNum className={state === 'not_billable' ? 'text-ink-subtle' : 'text-alert'}>
      <span className="flex flex-col items-end gap-0.5">
        <span className="font-sans text-xs">
          {LABEL[state as Exclude<ProjectRevenueState, 'ok'>]}
        </span>
        {state === 'partial_rate' ? (
          <span className="font-sans text-[11px] text-ink-subtle">{`うち ${hours(unratedHours)}`}</span>
        ) : null}
      </span>
    </TdNum>
  );
}
